import React from 'react'
import { Link } from 'gatsby'

const Banner = () => (
  <div className="banner">
    <Link to="/buy_crypto_currency">
      <h1>全球支付解决方案</h1>
      <p>使用推荐的渠道购买加密货币</p>
    </Link>
  </div>
)

export default Banner
